import { takeEvery, fork, put, all, call } from 'redux-saga/effects';
import cogoToast from 'cogo-toast';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { EXECUTE_RESOLUTION, EXECUTE_RESOLUTION_SUCCESS, EXECUTE_RESOLUTION_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* executeResolution({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    /* URL carries the resolution's own action_type as :issue_resolution_type.
       body: { resolution_id, booking_id, ... } — booking_id is only sent when the resolution came
       from a manually entered, verified booking ID */
    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/execute-resolution/${payload?.actionType}`,
      method: 'POST',
      headers: { ...filteredHeaders },
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message || 'Resolution executed successfully'}`);
      yield put({
        type: EXECUTE_RESOLUTION_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message || 'Unable to execute resolution'}`);
      yield put({
        type: EXECUTE_RESOLUTION_ERROR,
        payload: response?.response?.data?.message,
      });
    }
  } catch (error) {
    cogoToast.error('Unable to execute resolution');
    yield put({ type: EXECUTE_RESOLUTION_ERROR, payload: error });
  }
}

export function* watchExecuteResolution() {
  yield takeEvery(EXECUTE_RESOLUTION, executeResolution);
}

function* executeResolutionSaga() {
  yield all([fork(watchExecuteResolution)]);
}

export default executeResolutionSaga;
